import { ReactComponent as EditIconSVG } from '@/assets/icons/EditIcon.svg';
import { SVGProps } from 'react';

const EditIcon = (props: SVGProps<SVGSVGElement>) => <EditIconSVG {...props} />;

export default EditIcon;
